import { MRT_ColumnDef } from 'material-react-table';
import {  useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import {  ROUTER_PATHS, emptyCellOneLevel, hasAllPermissions, hasPermission, useCheckPermissions, useTableFilter } from '@/shared';
import { useFetchNaps, useUpdateNaps} from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import {Naps } from '@/shared/interfaces';
import { PermissionsEnum } from '@/auth/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';

const returnUrlPuertosDisponibles = ROUTER_PATHS.activaciones.activacionCajasPuertosDisponiblesNav;

export interface PuertosDisponiblesPageInterface {}

const PuertosDisponiblesPage: React.FC<PuertosDisponiblesPageInterface> = () => {

  useCheckPermissions(PermissionsEnum.api_view_nap)
const navigate = useNavigate();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;
    ///* fetch data
    const {
        data: NapsPagingRes,
        isLoading,
        isRefetching,
      } = useFetchNaps({
        page: pageIndex + 1,
        nombre: searchTerm,
      });
   ///* handlers
   const onEdit = (original: Naps) => {
    navigate(`${returnUrlPuertosDisponibles}/revisar/${original.id_nap}`);
  };
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );

  const updateNapsMutation = useUpdateNaps({navigate, returnUrl:returnUrlPuertosDisponibles});

  ///* columns
    const columns = useMemo<MRT_ColumnDef<Naps>[]>(
        () => [
          {
            accessorKey: 'numero_referencia',
            header: 'numero referencia',
            size: 200,
        },
      /*   {
          accessorKey: 'codigo',
          header: 'codigo',
          size: 200,
      }, */

        {
            accessorKey: 'nombre',
            header: 'nombre',
            size: 200,
        },
        {
            accessorKey: 'direccion',
            header: 'dirección',
            size: 200,
            Cell: ({ row }) => emptyCellOneLevel(row, 'direccion'),
        },
        {
            accessorKey: 'coordenadas',
            header: 'Coordenadas',
            size: 200,
        },
        {
            accessorKey: 'latitud',
            header: 'latitud',
            size: 200,
        },
        {
          accessorKey: 'longitud',
          header: 'longitud',
          size: 200,
      },
        {
            accessorKey: 'sector',
            header: 'sector',
            size: 200,
        },
        {
            accessorKey: 'ciudad',
            header: 'ciudad',
            size: 200,
        },
        {
          accessorKey: 'nodo',
          header: 'nodo',
          size: 200,
      },
      {
        accessorKey: 'estado_nap',
        header: 'Estado nap',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado_nap}
            titulo={row.original.estado_nap ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={naps => {
              if (!hasPermission(PermissionsEnum.api_change_nap)) return;

              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updateNapsMutation.mutate({
                    id: row.original.id_nap!,
                    data: {
                      ...row.original,
                      estado_nap: naps as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
      {
        accessorKey: 'es_soterrado',
        header: 'Soterrado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.es_soterrado}
            titulo={row.original.es_soterrado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={naps => {
              if (!hasPermission(PermissionsEnum.api_change_nap)) return;
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updateNapsMutation.mutate({
                    id: row.original.id_nap!,
                    data: {
                      ...row.original,
                      es_soterrado: naps as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado}
            titulo={row.original.estado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={estado => {
              if (!hasPermission(PermissionsEnum.api_change_nap)) return;
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updateNapsMutation.mutate({
                    id: row.original.id_nap!,
                    data: {
                      ...row.original,
                      estado: estado as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
        ],
        []
    );
    return (
        <SingleTableBoxScene title="Reporte de Cajas y Puertos disponibles">
          <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Naps" />

          <GeneralTable<Naps>
            columns={columns}
            data={NapsPagingRes?.data?.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={NapsPagingRes?.data?.count}
            // // actions
            actionsColumnSize={120}
            enableColumnActions={hasAllPermissions([
              PermissionsEnum.api_change_nap,
            ])}
            // crud
            onEdit={onEdit}
            canEdit={hasAllPermissions([
              PermissionsEnum.api_change_nap,
            ])}
            canDelete={false}
          />
        </SingleTableBoxScene>
      );
    };
    export default PuertosDisponiblesPage;